import Env from "../Env";
import Request from "./Request";

export default class ShippingAndReturnPolicyRequest extends Request {

  static savePolicy(data, handlerSuccess, handlerError, handlerComplete) {
    const url = Env.getBackendURL() + 'config/shipping_return/save';
    Request.submit(url, data, handlerSuccess, handlerError, handlerComplete);
  }

  static loadPolicy(handlerSuccess, handlerError, handlerComplete) {
    const url = Env.getBackendURL() + 'config/shipping_return/load';
    Request.load(url, handlerSuccess, handlerError, handlerComplete);
  }
}
